import { createApp } from 'vue'
import Istatistik from './Istatistik.vue'
import './assets/global.css'

createApp(Istatistik).mount('#istatistik')
